var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBrowsers = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 8.25C3 7.83579 2.66421 7.5 2.25 7.5C1.83579 7.5 1.5 7.83579 1.5 8.25V18C1.5 19.6569 2.84315 21 4.5 21H18.75C19.1642 21 19.5 20.6642 19.5 20.25C19.5 19.8358 19.1642 19.5 18.75 19.5H4.5C3.67157 19.5 3 18.8284 3 18V8.25Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 3C5.17157 3 4.5 3.67157 4.5 4.5V16.5C4.5 17.3284 5.17157 18 6 18H21C21.8284 18 22.5 17.3284 22.5 16.5V4.5C22.5 3.67157 21.8284 3 21 3H6ZM6.75 4.5C6.33579 4.5 6 4.83579 6 5.25V7.5H10.5V4.5H6.75ZM12 4.5H20.25C20.6642 4.5 21 4.83579 21 5.25V7.5H12V4.5ZM21 9H6V15.75C6 16.1642 6.33579 16.5 6.75 16.5H20.25C20.6642 16.5 21 16.1642 21 15.75V9Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBrowsers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/browsers.bdf211401f640a1d0009f290ee1d1665.svg";